<template>
  <van-button loading-text="Processing..." round size="small" class="btn" v-bind="$attrs">
    {{ text }}
  </van-button>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: white;
  border: none;
  background: linear-gradient(135deg, $bg-l-end, $bg-l-start);
}
</style>
